import { Card, icons } from '@lifebit-ai/lds'
import { ResultsState } from 'enums'
import React from 'react'

import { getExportAndAccessRequestDetailsPath } from 'modules/requests/requestDetailPaths'
import * as styles from 'modules/resultsV2/PreviousApprovalDetails.styles'
import type { Result } from 'services/results/types'
import { formatDate } from 'utils/date'

interface PreviousAttestationRejectedRequestDetailsProps {
  result: Result
}

export const PreviousAttestationRejectedRequestDetails = ({
  result
}: PreviousAttestationRejectedRequestDetailsProps): JSX.Element | null => {
  const previousRequests = result.attestationReview?.previousRequests?.length
    ? result.attestationReview.previousRequests
    : result.attestationReview?.previousRequest
    ? [result.attestationReview.previousRequest]
    : []
  const rejectedPreviousRequests = previousRequests.filter(request => request.status === ResultsState.Rejected)

  if (!rejectedPreviousRequests.length) return null

  return (
    <>
      {rejectedPreviousRequests.map((request, index) => {
        const originalRequestUrl = request._id
          ? getExportAndAccessRequestDetailsPath(request._id)
          : getExportAndAccessRequestDetailsPath('-')

        return (
          <Card key={request._id}>
            <styles.CardContent>
              <styles.CardSectionTitle>
                {rejectedPreviousRequests.length > 1
                  ? `Previously Rejected Request #${index + 1}`
                  : 'Previously Rejected Request'}
              </styles.CardSectionTitle>
              <styles.Details>
                <styles.Label>First original request link</styles.Label>
                <styles.Link href={originalRequestUrl} target="_blank" rel="noopener noreferrer">
                  <span>Original request</span>
                  <icons.OpenSmall />
                </styles.Link>
                <styles.Label>Originally rejected by</styles.Label>
                <styles.Value>{request.verifiedBy?.email ?? '-'}</styles.Value>
                <styles.Label>Original rejection date</styles.Label>
                <styles.Value>{formatDate(request.verifiedAt)}</styles.Value>
                <styles.Label>Reason for rejection</styles.Label>
                <styles.Value>{request.rejectionReason ?? '-'}</styles.Value>
              </styles.Details>
            </styles.CardContent>
          </Card>
        )
      })}
    </>
  )
}
